export default __webpack_public_path__ + "static/media/scene_3.34241e93.png";